module.exports = __webpack_public_path__ + "static/media/success-83493.3de91159.mp3";